import sumBy from 'lodash/sumBy'

import { formatCurrency } from 'lib/formatting/currency'
import { removeCommas } from 'utils/helpers'

import { RecordCollection } from './records-section'

export const toNumber = (value: unknown) =>
  Number(removeCommas(String(value ?? ''))) || 0

export const sumValues = (items: RecordCollection['items']) =>
  sumBy(items, (item) => toNumber(item.attributes.value))

const getValueTotal = (items: RecordCollection['items']) =>
  formatCurrency({ value: sumValues(items) })

export default getValueTotal
